<!-- 請求仕入れ一覧データダウンロード -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="contents1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <!-- パンくずリスト -->
        <BreadcrumbsComponent :title="''" :categoryId="categoryId" />
        <!-- エラーメッセージの表示エリア -->
        <div
          v-if="errorMessage"
          class="error-message com_mgb10"
          style="white-space: pre-wrap"
        >
          {{ errorMessage }}
        </div>
        <!-- 検索条件 -->
        <div class="com_block1">
          <!-- エージェント一覧 -->
          <div>
            <h2>エージェントコード</h2>
            <p class="com_fs12 com_color1">※必須項目です</p>
          </div>
          <div>
            <table class="com_a_table1">
              <colgroup>
                <col style="width: 5%" />
                <col style="width: 15%" />
                <col style="width: 80%" />
              </colgroup>
              <thead>
                <tr>
                  <th style="width: 5%">
                    <label class="com_checkbox3">
                      <input
                        type="checkbox"
                        :checked="isAllChecked"
                        class="check_all1"
                        @change="toggleAllAgents"
                      />
                    </label>
                  </th>
                  <th>コード</th>
                  <th>エージェント名</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(agent, index) in agList" :key="index">
                  <td>
                    <label class="com_checkbox3">
                      <input
                        type="checkbox"
                        v-model="agent.selection"
                        class="check_all1"
                      />
                    </label>
                  </td>
                  <td>{{ agent.agCode }}</td>
                  <td>{{ agent.agName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--請求年月/締め日 -->
        <div class="com_block1">
          <div>
            <h2>請求年月/締め日</h2>
            <p class="com_fs12 com_color1">※必須項目です</p>
          </div>
          <div>
            <div class="com_b_cnt1">
              <div class="com_f_group1">
                <!-- 請求年月 -->
                <select v-model="selectedYear" class="com_f_control1">
                  <option v-for="year in yearOptions" :key="year" :value="year">
                    {{ year }}年
                  </option>
                </select>
                <select v-model="selectedMonth" class="com_f_control1">
                  <option
                    v-for="month in monthOptions"
                    :key="month"
                    :value="month"
                  >
                    {{ String(month).padStart(2, "0") }}月
                  </option>
                </select>
                <!-- 締め日 -->
                <span style="margin-left: 8px; margin-right: 8px">締め日</span>
                <select v-model="selectedCloseDay" class="com_f_control1">
                  <option
                    v-for="closeDay in closeDayOptions"
                    :key="closeDay"
                    :value="closeDay"
                  >
                    {{
                      closeDay === "99"
                        ? "月末"
                        : String(closeDay).padStart(2, "0") + "日"
                    }}
                  </option>
                </select>
              </div>
              <p class="com_fs15 com_lh14 com_mgt10 com_mgb0">
                {{
                  getValueById(
                    displayMessages,
                    SeikyuRptDownloadConstants.KEY_DISPLAY_TEXT_BILLING_CLOSE_NOTE
                  )
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- ボタン部 -->
        <div class="com_u_cnt1">
          <div class="com_inner1 clearfix">
            <div>
              <router-link
                :to="{ name: 'ReportDownload' }"
                class="com_link2 b"
                style="margin-left: 12px"
                >各種ダウンロードへ戻る</router-link
              >
            </div>
            <div>
              <button
                type="button"
                name="btnSerch"
                class="com_search_button1"
                style="width: 220px"
                @click="onSerch"
              >
                請求仕入合計検索
              </button>
              <button
                type="button"
                name="btnClear"
                class="com_clear_button1"
                style="width: 120px; margin-right: 12px"
                @click="onClear"
              >
                クリア
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 検索結果 -->
      <div
        v-if="outputDataList.length > 0"
        class="com_inner1 clearfix com_mgt15"
      >
        <!-- 上部メッセージ -->
        <p class="description">
          請求仕入合計ファイルを作成しました。ダウンロードリンクをクリックし、ファイルを保存してください。
        </p>
        <!-- 操作エリア -->
        <div class="div-kan com_mgb10">
          <div style="display: flex">
            <div>
              <button
                type="button"
                name="btnDownload"
                class="uri_res_button1"
                @click="
                  onDownload(
                    SeikyuRptDownloadConstants.DOWNLOAD_TYPE_ZIP,
                    zipFileName
                  )
                "
              >
                全ファイルダウンロード
              </button>
            </div>
          </div>
        </div>
        <!-- ファイル一覧 -->
        <div style="width: 900px">
          <table class="com_a_table1">
            <thead>
              <tr>
                <th style="width: 20%">エージェントコード</th>
                <th style="width: 35%">エージェント名</th>
                <th style="width: 45%">ダウンロードリンク</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in outputDataList" :key="index">
                <td>{{ data.agCode }}</td>
                <td>{{ data.agName }}</td>
                <td>
                  <a
                    href="#"
                    class="com_link1"
                    @click.prevent="
                      onDownload(
                        SeikyuRptDownloadConstants.DOWNLOAD_TYPE_TSV,
                        data.rptName
                      )
                    "
                    >{{ data.rptName }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
  <LoadingOverlayComponent v-if="isLoading" :lines="loadLines" />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  isTokenAlive,
  scrollToTop,
  commonHandleAxiosError,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import "vue-loading-overlay/dist/css/index.css";
import LoadingOverlayComponent from "../layout/LoadingOverlayComponent.vue";

interface agData {
  selection: boolean; // 選択
  agCode: string; // AGコード
  agName: string; // AG名
}
interface OutputData {
  agCode: string; // AGコード
  agName: string; // AG名
  rptName: string; // 請求仕入れ一覧データファイル名
}
interface KeyValueItem {
  id: string; // ID
  value: string; // 値
}

class SeikyuRptDownloadConstants {
  // ダウンロード形式
  static readonly DOWNLOAD_TYPE_TSV = "1"; // tsvファイル
  static readonly DOWNLOAD_TYPE_ZIP = "2"; // zipファイル
  static readonly DOWNLOAD_TYPE_TEMPLATE = "3"; // テンプレートファイル

  // キー
  static readonly KEY_DISPLAY_TEXT_BILLING_CLOSE_NOTE = "BillingCloseNote"; // 請求年月/締め日補足
  static readonly KEY_BILLING_YM_SETTINGS_YEAR_MIN_VALUE = "YearMinValue"; // 年の選択肢の最小値
  static readonly KEY_BILLING_YM_SETTINGS_YEAR_DISPLAY_COUNT =
    "YearDisplayCount"; // 年の選択肢の表示数
}

export default defineComponent({
  name: "SeikyuRptDownloadComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    BackToTop,
    LoadingOverlayComponent,
  },
  setup() {
    const router = useRouter();
    const { getCategoryIdByName } = useUserParmitionStore();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const daihyoCode = ref(""); // 代表コード
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const pseudoDaihyoCode = ref(""); // 疑似ログイン代表コード
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const serchDaihyoCode = ref(""); // 検索用代表コード
    const categoryId = ref(""); // カテゴリID
    const agList = ref<agData[]>([]); // AGデータリスト
    const displayMessages = ref<KeyValueItem[]>([]); // 画面メッセージリスト
    const billingYmSettings = ref<KeyValueItem[]>([]); // 請求年月の設定値リスト
    // 検索結果のデータリスト
    const outputDataList = ref<OutputData[]>([]);
    const outputSeq = ref(""); // 出力シーケンス
    const zipFileName = ref(""); // ZIPファイル名
    const isLoading = ref(false); // ブロッキングオーバーレイの表示フラグ
    const loadLines = ref<string[]>([]); // ブロッキングオーバーレイのメッセージ

    // 画面表示用
    const yearOptions = ref<number[]>([]);
    const monthOptions = ref<number[]>([]);
    const closeDayOptions = ref<string[]>([]);

    // 初期値/選択値
    const initialYear = ref<number | null>(null);
    const initialMonth = ref<number | null>(null);
    const selectedYear = ref<number | null>(null);
    const selectedMonth = ref<number | null>(null);
    const selectedCloseDay = ref<string>("");

    // IDから値を取得するユーティリティ関数
    const getValueById = (list: KeyValueItem[], id: string): string => {
      const item = list.find((x) => x.id === id);
      return item ? item.value : "";
    };

    // 年月から年を取得
    const getYearFromYm = (ym: number): number => {
      return Math.floor(ym / 100);
    };

    // 年月から月を取得
    const getMonthFromYm = (ym: number): number => {
      return ym % 100;
    };

    // 年の選択肢を作成
    const createYearOptions = (): number[] => {
      const baseYear = Number(initialYear.value);

      if (!Number.isFinite(baseYear)) {
        // 初期年月が不正な場合は、年の選択肢を作成できないため、空の配列を返す
        return [];
      }

      const yearMinValue = Number(
        getValueById(
          billingYmSettings.value,
          SeikyuRptDownloadConstants.KEY_BILLING_YM_SETTINGS_YEAR_MIN_VALUE
        )
      );
      const yearDisplayCount = Number(
        getValueById(
          billingYmSettings.value,
          SeikyuRptDownloadConstants.KEY_BILLING_YM_SETTINGS_YEAR_DISPLAY_COUNT
        )
      );

      const minYear = Number.isFinite(yearMinValue) ? yearMinValue : 2023; // 設定値が不正な場合は、2023年を最小値とする（ベースAG踏襲）
      const displayCount = Number.isFinite(yearDisplayCount)
        ? yearDisplayCount
        : 2; // 設定値が不正な場合は、2年分を表示（ベースAG踏襲）

      return Array.from(
        { length: displayCount + 1 },
        (_, i) => baseYear - i
      ).filter((year) => year >= minYear);
    };

    // 月の選択肢を作成
    const createMonthOptions = (): number[] => {
      return Array.from({ length: 12 }, (_, i) => i + 1);
    };

    // 選択された年月を「YYYYMM」形式の文字列で取得
    const getSeikyuYm = (): string => {
      if (selectedYear.value && selectedMonth.value) {
        return `${selectedYear.value}${String(selectedMonth.value).padStart(
          2,
          "0"
        )}`;
      }
      return "";
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          daihyoCode.value = parsedUserInfo.daihyoCode;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          pseudoDaihyoCode.value = parsedUserInfo.pseudoDaihyoCode;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
            serchDaihyoCode.value = daihyoCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
            serchDaihyoCode.value = pseudoDaihyoCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // カテゴリID取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_SEIKYU_RPT
        ) as string;

        // 初期表示データ取得API
        const response = await apiAuthClient.post(
          "/api/SeikyuRptDownload/getInitialData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            kanriAgCode: pseudoAgCode.value,
            kanriUserId: pseudoUserId.value,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        agList.value = data.agList;
        billingYmSettings.value = data.billingYmSettings;

        initialYear.value = getYearFromYm(data.initialBillingYm);
        initialMonth.value = getMonthFromYm(data.initialBillingYm);

        // 年と月、締め日の選択肢を作成
        yearOptions.value = createYearOptions();
        monthOptions.value = createMonthOptions();
        displayMessages.value = data.displayMessages;
        closeDayOptions.value = data.closedDays;

        // 初期化
        initializeItems();

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";
        // 入力項目クリア
        initializeItems();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 検索ボタン押下
     */
    const onSerch = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック
        if (!validateInput()) {
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        showLoading([
          "検索中です...",
          "画面を触らないでください",
          "検索条件によって時間がかかることがあります",
        ]);

        // 検索結果クリア
        outputDataList.value = [];

        // 請求仕入れ一覧データ情報一覧取得API実行
        const response = await apiAuthClient.post(
          "/api/SeikyuRptDownload/getRptList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            agList: agList.value
              .filter((item) => item.selection)
              .map((item) => ({
                agCode: item.agCode,
              })),
            seikyuYm: getSeikyuYm(),
            seikyuDay: String(selectedCloseDay.value).padStart(2, "0"),
          }
        );

        const data = response.data;
        outputDataList.value = data.searchResultList;
        outputSeq.value = data.outputSeq;
        zipFileName.value = data.zipFileName;

        if (outputDataList.value.length === 0) {
          errorMessage.value = formatMessage(
            messages.ERR_0009,
            "該当するデータ"
          );
          // スクロールを一番上に戻す
          scrollToTop();
          return;
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        processingStore.isProcessing = false;
        hideLoading();
      }
    };

    /**
     * ダウンロードボタン押下
     */
    const onDownload = async (
      downloadType: string,
      downloadFileName: string
    ) => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 請求仕入れ一覧データダウンロードAPI実行
        const response = await apiAuthClient.post(
          "/api/SeikyuRptDownload/downloadRpt",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            outputSeq: outputSeq.value,
            downloadType: downloadType,
            downloadFileName: downloadFileName,
          },
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // サーバ側から返されたファイル名を取得
        const disposition = response.headers["content-disposition"];
        let fileName = "download.csv";
        if (disposition && disposition.includes("filename*=UTF-8")) {
          const matches = /filename\*=UTF-8''(.+)/.exec(disposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    const initializeItems = () => {
      for (const ag of agList.value) {
        ag.selection = true; // 初期状態では全て選択された状態にする
      }
      selectedYear.value = initialYear.value;
      selectedMonth.value = initialMonth.value;
      selectedCloseDay.value = closeDayOptions.value[0] ?? "";
      outputDataList.value = [];
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 必須チェック
      if (agList.value.filter((item) => item.selection).length === 0) {
        errorMessage.value = formatMessage(
          messages.ERR_0003,
          "エージェントコード"
        );
        return false;
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * ローディングオーバーレイの表示
     */
    const showLoading = (lines: string[]) => {
      loadLines.value = lines;
      isLoading.value = true;
    };

    /**
     * ローディングオーバーレイの非表示
     */
    const hideLoading = () => {
      isLoading.value = false;
      loadLines.value = [];
    };

    let prevOverflow = ""; // 元のオーバーフロースタイルを保存する変数
    /**
     * ローディングオーバーレイ表示中のスクロール制御
     */
    watch(isLoading, (v) => {
      if (v) {
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = prevOverflow;
      }
    });

    /**
     * コンポーネントがアンマウントされる際にオーバーフローをリセット
     * - ローディングオーバーレイが表示されたままコンポーネントが破棄された場合でも、
     * - スクロールができなくなるのを防止するための措置
     */
    onBeforeUnmount(() => {
      document.body.style.overflow = prevOverflow;
    });

    const isAllChecked = computed(() => {
      return agList.value.length > 0 && agList.value.every((x) => x.selection);
    });

    const toggleAllAgents = (event: Event) => {
      const checked = (event.target as HTMLInputElement).checked;
      agList.value.forEach((agent) => {
        agent.selection = checked;
      });
    };

    return {
      AppConstants,
      SeikyuRptDownloadConstants,
      onClear,
      onSerch,
      onDownload,
      initializeItems,
      toggleAllAgents,
      scrollToTop,
      getValueById,
      isInitError,
      isDataFetched,
      isLoading,
      loadLines,
      isKaunetAdmin,
      errorMessage,
      categoryId,
      agList,
      isAllChecked,
      outputDataList,
      zipFileName,
      selectedYear,
      selectedMonth,
      selectedCloseDay,
      yearOptions,
      monthOptions,
      displayMessages,
      closeDayOptions,
    };
  },
});
</script>
